import { render, staticRenderFns } from "./DPHL.vue?vue&type=template&id=fcabf16c&scoped=true"
import script from "./DPHL.vue?vue&type=script&lang=js"
export * from "./DPHL.vue?vue&type=script&lang=js"
import style0 from "./DPHL.vue?vue&type=style&index=0&id=fcabf16c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcabf16c",
  null
  
)

export default component.exports